import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.css';

export interface Props {
    children: React.ReactChildren | string | string[];
    className?: string;
    type?: 'button' | 'submit';
    buttonType?: 'primary' | 'secondary';
    onClick?: any;
    disabled?: boolean;
}

const Button: React.FC<Props> = ({
    children,
    className,
    type = 'button',
    buttonType = 'primary',
    onClick,
    disabled,
}) => (
    <button
        type={type}
        disabled={disabled}
        className={classNames(className, {
            [styles.btn]: buttonType === 'primary',
            [styles.secondary]: buttonType === 'secondary',
            [styles.disabled]: disabled,
        })}
        onClick={onClick}
    >
        {children}
    </button>
);

export default Button;
